import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import FinishLeadFirst from "./finishLeadFirst.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditLeadStatus = (props) => {
  const [value, setValue] = useState(props.leadData.status);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [showFinishLead, setShowFinishLead] = useState(false);

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (props.uData.adminSprzedaz === "1") {
          setBanks(data);
        } else {
          setBanks(
            data.filter((el) => el.status !== "zakończono proces sprzedażowy")
          );
        }

        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const editLeadAcc = () => {
    if (
      value === "oznaczono do zamknięcia" &&
      (reason === "klient wybrał inną kancelarię" ||
        reason === "klient podpisał ugodę z bankiem" ||
        reason === "klient zrezygnował ze sprawy sądowej")
    ) {
      editLead();
    } else if (value === "oznaczono do zamknięcia") {
      MySwal.fire({
        title:
          "Czy próbowałeś nawiązać kontakt z klientem co najmniej trzy razy?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then((result) => {
        if (result.isConfirmed) {
          editLead();
        } else if (result.isDenied) {
          MySwal.fire({
            icon: "error",
            title: "Nie zmieniono",
            text: "statusu",
          }).then(async (result) => {
            props.close();
          });
        }
      });
    } else {
      editLead();
    }
  };

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var statusOri = value;
      var status = value;
      if (
        value === "oznaczono do zamknięcia" &&
        (reason === "klient wybrał inną kancelarię" ||
          reason === "klient podpisał ugodę z bankiem" ||
          reason === "klient zrezygnował ze sprawy sądowej")
      ) {
        status = "zamknięty";
      }

      var body = {
        leadId: props.leadData.id,
        value: status,
        reason: reason,
        leadName: props.leadData.name,
        type:
          props.leadData.status === "ponowna próba uzyskania umowy" ||
          props.leadData.status === "pierwsza próba uzyskania umowy"
            ? "consultant"
            : "user",
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLeadStatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Zmiana statusu sprawy: " + props.user,
        props.leadData.id
      );

      if (status === "mamy podpisaną umowę o współpracę") {
        finishLead();
      } else if (statusOri === "zamknięty") {
        archivizeLead();
      } else if (
        value === "oznaczono do zamknięcia" &&
        (reason === "klient wybrał inną kancelarię" ||
          reason === "klient podpisał ugodę z bankiem" ||
          reason === "klient zrezygnował ze sprawy sądowej")
      ) {
        archivizeLeadAccept();
      } else {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "lead",
        }).then(async (result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleCloseFinishLead = (e) => {
    setShowFinishLead(false);
    props.close();
  };

  const handleCloseFinishLeadS = (e) => {
    MySwal.fire({
      icon: "success",
      title: "Sprawa",
      text: "została przekazana do założenia",
    }).then(async (result) => {
      setShowFinishLead(false);
      props.close();
    });
  };

  const changeStatus = (e) => {
    setValue(e.target.value);
    if (e.target.value !== "oznaczono do zamknięcia") {
      setReason("");
    }
  };

  const finishLead = (e) => {
    MySwal.fire({
      title: "Czy chcesz zlecić założenie sprawy?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        setShowFinishLead(true);
      } else if (result.isDenied) {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "lead",
        }).then(async (result) => {
          props.close();
        });
      }
    });
  };

  const archivizeLead = () => {
    MySwal.fire({
      title: "Czy chcesz zarchiwizować kontakt?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        archivizeLeadAccept();
      } else if (result.isDenied) {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "lead",
        }).then(async (result) => {
          props.close();
        });
      }
    });
  };

  const archivizeLeadAccept = async () => {
    var body = {
      id: props.leadData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        if (
          value === "oznaczono do zamknięcia" &&
          (reason === "klient wybrał inną kancelarię" ||
            reason === "klient podpisał ugodę z bankiem" ||
            reason === "klient zrezygnował ze sprawy sądowej")
        ) {
          MySwal.fire("Edytowano", "lead", "success").then((result) => {
            props.closeFull();
          });
        } else {
          MySwal.fire("Zarchiwizowano", "kontakt", "success").then((result) => {
            props.closeFull();
          });
        }
      })
      .catch((error) => {});
  };

  return (
    <div className="mainContainerAddClientContact">
      {showFinishLead ? (
        <>
          <FinishLeadFirst
            close={handleCloseFinishLead}
            closeS={handleCloseFinishLeadS}
            user={props.uData}
            leadData={props.leadData}
            logLeadAction={props.logLeadAction}
            mode={
              props.leadData.finishCourt !== null ||
              props.leadData.finishCaseCh !== null ||
              props.leadData.finishTeam !== null
                ? "filled"
                : ""
            }
          />
        </>
      ) : (
        ""
      )}
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Status <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={value}
                onChange={changeStatus}
              >
                {!value ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                {props.leadData.status === "pierwsza próba uzyskania umowy" ? (
                  <>
                    <option key={9991} value={"nowe zgłoszenie"}>
                      {"nowe zgłoszenie"}
                    </option>
                    <option
                      key={9992}
                      value={"uzyskana umowa przez konsultanta"}
                    >
                      {"uzyskana umowa przez konsultanta"}
                    </option>
                    <option key={9993} value={"oznaczono do zamknięcia"}>
                      {"oznaczono do zamknięcia"}
                    </option>
                    <option key={9995} value={"pierwsza próba uzyskania umowy"}>
                      {"pierwsza próba uzyskania umowy"}
                    </option>
                  </>
                ) : props.leadData.status ===
                  "ponowna próba uzyskania umowy" ? (
                  <>
                    <option key={9991} value={"nowe zgłoszenie"}>
                      {"nowe zgłoszenie"}
                    </option>
                    <option
                      key={9992}
                      value={"uzyskana umowa przez konsultanta"}
                    >
                      {"uzyskana umowa przez konsultanta"}
                    </option>
                    <option key={9993} value={"oznaczono do zamknięcia"}>
                      {"oznaczono do zamknięcia"}
                    </option>
                    <option key={9994} value={"ponowna próba uzyskania umowy"}>
                      {"ponowna próba uzyskania umowy"}
                    </option>
                  </>
                ) : (
                  banks.map((el) => (
                    <>
                      <option key={el.id} value={el.status}>
                        {el.status}
                      </option>
                    </>
                  ))
                )}
                {props.uData.zamKon === "1" ? (
                  <>
                    <option key={9999} value={"zamknięty"}>
                      {"zamknięty"}
                    </option>
                  </>
                ) : (
                  ""
                )}
              </select>
            </div>
          </div>
          {value === "oznaczono do zamknięcia" ? (
            <>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Przyczyna zamknięcia <span className="requiredStar">*</span>
                  </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                  >
                    {!reason ? (
                      <>
                        <option key={0} value={0}>
                          Wybierz...
                        </option>
                      </>
                    ) : (
                      ""
                    )}
                    <option key={0} value={"brak nawiązania kontaktu"}>
                      {"brak nawiązania kontaktu"}
                    </option>
                    <option
                      key={1}
                      value={
                        "nawiązano kontakt-klient nie przesłał umowy do analizy"
                      }
                    >
                      {"nawiązano kontakt-klient nie przesłał umowy do analizy"}
                    </option>
                    <option key={2} value={"klient wybrał inną kancelarię"}>
                      {"klient wybrał inną kancelarię"}
                    </option>
                    <option key={3} value={"klient podpisał ugodę z bankiem"}>
                      {"klient podpisał ugodę z bankiem"}
                    </option>
                    <option
                      key={4}
                      value={"klient zrezygnował ze sprawy sądowej"}
                    >
                      {"klient zrezygnował ze sprawy sądowej"}
                    </option>
                    <option key={5} value={"zdublowany kontakt"}>
                      {"zdublowany kontakt"}
                    </option>
                    <option key={6} value={"zgłoszenie fałszywe"}>
                      {"zgłoszenie fałszywe"}
                    </option>
                    <option
                      key={7}
                      value={"negatywna rekomendacja na drogę sądową"}
                    >
                      {"negatywna rekomendacja na drogę sądową"}
                    </option>
                    <option key={8} value={"brak kontaktu po wysłaniu oferty"}>
                      {"brak kontaktu po wysłaniu oferty"}
                    </option>
                  </select>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLeadAcc}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadStatus;
